import { type RadioProps, Radio as AntdRadio } from 'antd';
import { RadioListItem } from './components/ListItem';
import { RadioTextPillItem } from './components/TextPillItem';
import { StyledRadio } from './components/StyledRadio';

const { Group, Button } = AntdRadio;

export function Radio(props: RadioProps): JSX.Element {
  const { children } = props;

  return <StyledRadio $hasChildren={children !== undefined} {...props} />;
}

Radio.Button = Button;
Radio.ListItem = RadioListItem;
Radio.TextPillItem = RadioTextPillItem;
Radio.Group = Group;
